import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import moment from 'moment-timezone';

@Component({
  selector: 'app-partial-entry-document',
  templateUrl: './partial-entry-document.component.html',
  styleUrls: ['./partial-entry-document.component.scss'],
  standalone: false,
})
export class PartialEntryDocumentComponent {
  @Input() controls: { [key: string]: FormControl };
  @Input() minValidDate: moment.Moment;
  @Input() maxValidDate: moment.Moment;
  @Input() maxValidFutureDate: moment.Moment;
  @Input() documentIssuePickerStartDate: moment.Moment;
  @Input() documentExpiryPickerStartDate: moment.Moment;
}
